import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createFileManagementRequest = () =>
  createRequest(BizAppConfig.fileManagementApiUrl || BizAppConfig.appApiUrl);
export const createLlmManageRequest = () =>
  createRequest(BizAppConfig.llmManageApiUrl || BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
